module.exports = __webpack_public_path__ + "static/self-09cd96a667e923e80153b4ef94ea1b2d.jpg";